import React, { memo, useState } from 'react';
import { NodeProps, NodeResizer } from '@xyflow/react';

interface SectionGroupData extends Record<string, unknown> {
  label: string;
  color: string;
  section_key: string;
  onLabelChange?: (newLabel: string) => void;
}

interface SectionGroupNodeProps extends NodeProps {
  data: SectionGroupData;
  selected: boolean;
}

const SectionGroupNode: React.FC<SectionGroupNodeProps> = memo(({ data, selected }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(data.label);

  const color = data.color || '#4A90D9';

  const handleBlur = () => {
    setEditing(false);
    if (draft !== data.label && data.onLabelChange) {
      data.onLabelChange(draft);
    }
  };

  return (
    <>
      <NodeResizer
        isVisible={selected}
        minWidth={200}
        minHeight={120}
        color={color}
      />
      <div
        style={{
          width: '100%',
          height: '100%',
          border: `2px solid ${color}`,
          borderRadius: 10,
          background: `${color}26`,
          boxSizing: 'border-box',
          pointerEvents: 'none',
        }}
      >
        <div
          style={{
            padding: '6px 12px',
            borderBottom: `1px solid ${color}66`,
            background: `${color}33`,
            borderRadius: '8px 8px 0 0',
            pointerEvents: 'all',
          }}
        >
          {editing ? (
            <input
              autoFocus
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              onBlur={handleBlur}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleBlur();
                if (e.key === 'Escape') {
                  setDraft(data.label);
                  setEditing(false);
                }
              }}
              style={{
                background: 'transparent',
                border: 'none',
                outline: 'none',
                fontWeight: 700,
                fontSize: 13,
                color,
                width: '100%',
              }}
            />
          ) : (
            <div
              onClick={() => {
                setDraft(data.label);
                setEditing(true);
              }}
              style={{
                fontWeight: 700,
                fontSize: 13,
                color,
                cursor: 'text',
                userSelect: 'none',
              }}
            >
              {data.label || 'New Section'}
            </div>
          )}
        </div>
      </div>
    </>
  );
});

SectionGroupNode.displayName = 'SectionGroupNode';

export default SectionGroupNode;
